import { render } from "./TaskItem.vue?vue&type=template&id=6b5f02aa&scoped=true&ts=true"
import script from "./TaskItem.ts?vue&type=script&lang=ts"
export * from "./TaskItem.ts?vue&type=script&lang=ts"

import "./TaskItem.scss?vue&type=style&index=0&id=6b5f02aa&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b5f02aa"]])

export default __exports__